(function () {
  if(document.body.id !== 'sakagura') return false
  setMap()

  function setMap() {
    var map = document.querySelector('.js-sakagura-map')
    if(!map) return false

    var main = document.querySelector('.js-sakagura-main')
    var img = document.querySelector('.js-sakagura-img')
    main.classList.add('is-show')
    img.classList.add('is-show')
    var close = document.querySelector('.js-sakagura-img-close')
    close.addEventListener('click', imgClose)
  
    function imgClose() {
      main.classList.remove('is-show')
      img.classList.remove('is-show')
      map.classList.add('is-img-close')
    }
  
    var obj = document.querySelectorAll('.js-map-obj')
  
    for(var i=0; i < obj.length; i++) { 
      obj[i].addEventListener('mouseover', objOver)
      obj[i].addEventListener('mouseout', objOut)
    }
  
    function objOver(e) {
      var marker =document.querySelector('.js-map-marker-'+e.target.getAttribute('data-target'))
      marker.classList.add('is-active')
    }
  
    function objOut(e) {
      var marker =document.querySelector('.js-map-marker-'+e.target.getAttribute('data-target'))
      marker.classList.remove('is-active')
    }
  }

}());